var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSparkle2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sparkle",
    clipPath: "url(#clip0_0_1095)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.78702 0.74251C3.72717 0.792213 3.68659 0.861282 3.67231 0.937753L3.32195 2.79057C3.29706 2.9223 3.23305 3.04346 3.13825 3.13825C3.04346 3.23305 2.9223 3.29706 2.79057 3.32195L0.937753 3.67231C0.861282 3.68659 0.792213 3.72717 0.74251 3.78702C0.692808 3.84686 0.6656 3.92221 0.6656 4C0.6656 4.07779 0.692808 4.15314 0.74251 4.21298C0.792213 4.27283 0.861282 4.31341 0.937753 4.32769L2.79057 4.67805C2.9223 4.70294 3.04346 4.76695 3.13825 4.86175C3.23305 4.95654 3.29706 5.0777 3.32195 5.20943L3.67231 7.06225C3.68659 7.13872 3.72717 7.20779 3.78702 7.25749C3.84686 7.30719 3.92221 7.3344 4 7.3344C4.07779 7.3344 4.15314 7.30719 4.21298 7.25749C4.27283 7.20779 4.31341 7.13872 4.32769 7.06225L4.67805 5.20943C4.70294 5.0777 4.76695 4.95654 4.86175 4.86175C4.95654 4.76695 5.0777 4.70294 5.20943 4.67805L7.06225 4.32769C7.13872 4.31341 7.20779 4.27283 7.25749 4.21298C7.30719 4.15314 7.3344 4.07779 7.3344 4C7.3344 3.92221 7.30719 3.84686 7.25749 3.78702C7.20779 3.72717 7.13872 3.68659 7.06225 3.67231L5.20943 3.32195C5.0777 3.29706 4.95654 3.23305 4.86175 3.13825C4.76695 3.04346 4.70294 2.9223 4.67805 2.79057L4.32769 0.937753C4.31341 0.861282 4.27283 0.792213 4.21298 0.74251C4.15314 0.692808 4.07779 0.6656 4 0.6656C3.92221 0.6656 3.84686 0.692808 3.78702 0.74251Z",
    stroke: "#0D0D0D",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1095"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkle2);
export default __webpack_public_path__ + "static/media/sparkle-2.836cf8364929f76391e2598795c8ab7a.svg";
export { ForwardRef as ReactComponent };